module.exports = __webpack_public_path__ + "static/media/desktop_illustration_side4_side5_xmas.10b73920.png";